export default __webpack_public_path__ + "static/Group87-82dd80dee21cbdfeec2c3f0aa2cba687.jpeg";